import { render, staticRenderFns } from "./preferenceForm.vue?vue&type=template&id=636c11a0"
import script from "./preferenceForm.vue?vue&type=script&lang=js"
export * from "./preferenceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports